import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import {mediaSizes} from "~/theme";

function UIContainer({className, ...props}) {
  const classes = useStyles();

  return (
    <div
      className={cn(classes.root, className)}
      {...props}
    />
  )
}

const useStyles = createUseStyles({
  root: {
    width: 1200,
    paddingRight: 15,
    paddingLeft: 15,
    marginRight: 'auto',
    marginLeft: 'auto',
    boxSizing: 'border-box',

    [mediaSizes['md']]: {
      width: 768,
    },
  },
});

export default UIContainer;
